import { create } from "zustand";
import { TInventory } from "~/types";

export type DeconsolidateState = {
  step: number;
  selectedContainer?: TInventory;
  selectedPieces: TInventory[];
  listPieces: TInventory[];
  listContainers: TInventory[];
};

export type DeconsolidateActions = {
  setStep: (step: number) => void;
  setSelectedContainer: (container: TInventory) => void;
  setSelectedPieces: (pieces: TInventory[]) => void;
  setListPieces: (pieces: TInventory[]) => void;
  setListContainers: (containers: TInventory[]) => void;

  resetState: () => void;
};

export type DeconsolidateStore = DeconsolidateState & DeconsolidateActions;

export const useDeconsolidateStore = create<DeconsolidateStore>((set) => ({
  step: 1,
  selectedPieces: [],
  listPieces: [],
  listContainers: [],
  setStep: (step: number) => set(() => ({ step })),
  setSelectedContainer: (container) =>
    set(() => ({ selectedContainer: container })),
  setSelectedPieces: (pieces) => set(() => ({ selectedPieces: pieces })),
  setListPieces: (pieces) => set(() => ({ listPieces: pieces })),
  setListContainers: (containers) =>
    set(() => ({ listContainers: containers })),
  resetState: () =>
    set(() => ({
      step: 1,
      selectedContainer: undefined,
      selectedPieces: [],
      listPieces: [],
      listContainers: [],
    })),
}));
